import { FieldValues, Path, UseFormReturn, useWatch } from "react-hook-form";
import { ShipSettingForm } from "../../types/shipSetting";
import { LabelAndSelect } from "../reuseables/form.comp";
import MultipleCategoriesSelector from "../reuseables/multipleCategoriesSelector";

type CategoryRestrictionFormProps<T extends FieldValues> = {
  methods: UseFormReturn<T>;
  typeFieldName: Path<T>;
  idsFieldName: Path<T>;
};

export default function CategoryRestrictionForm<T extends FieldValues>({
  methods,
  typeFieldName,
  idsFieldName,
}: CategoryRestrictionFormProps<T>) {
  const restrictionType = useWatch({
    name: typeFieldName,
    control: methods.control,
  });

  return (
    <div>
      <LabelAndSelect
        methods={methods}
        label={"Category Restriction"}
        topLabelCss="block w-full"
        fieldName={typeFieldName}
        options={[
          { label: "None", value: "none" },
          { label: "Inclusion", value: "inclusion" },
          { label: "Exclusion", value: "exclusion" },
        ]}
      />

      {restrictionType && restrictionType !== "none" ? (
        <div className="space-y-4">
          <MultipleCategoriesSelector btnId="add-category-restriction-btn" methods={methods} fieldName={idsFieldName} />
        </div>
      ) : null}
    </div>
  );
}
